<template>
  <div class="batch-card-packaging-icon">
    <div
      :id="'batch-card-packaging-' + index"
      class="batch-card-packaging-icon__regular"
    >
      <svg-loader
        v-if="iconPath"
        :src="iconPath"
        :class="packagingColor"
      />

      <md-tooltip
        md-delay="100"
        md-direction="bottom"
      >
        {{ packagingName }}
      </md-tooltip>
    </div>
  </div>
</template>


<script>
import strings from '@/strings'

export default {
  name: 'BatchCardPackagingIcon',
  props: {
    packagingId: {
      type: Number
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    packagingInformation() {
      return strings.packagingStatus.find((status) => status.id === this.packagingId)
    },
    packagingState() {
      return this.packagingInformation?.state
    },
    packagingName() {
      return this.packagingInformation?.name
    },
    packagingColor() {
      return this.packagingInformation?.color
    },
    iconPath() {
      if (this.packagingState) {
        return `/static/images/icon-${this.packagingState}.svg`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-packaging-icon {
  margin-bottom: 0.25rem;

  &__regular {
    width: 30px;
    height: 30px;
    cursor: help;
    position: relative;
    float: right;

    .md-icon {
      border-radius: 10%;
      padding: 4px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
